import React from 'react';
import { CheckCircleIcon, ArchiveIcon } from 'lucide-react';
interface BudgetStatusBadgeProps {
  status: 'Active' | 'Archived';
  size?: 'sm' | 'md' | 'lg';
}
export function BudgetStatusBadge({
  status,
  size = 'md'
}: BudgetStatusBadgeProps) {
  const getStatusStyles = () => {
    switch (status) {
      case 'Active':
        return {
          bg: 'bg-green-100',
          text: 'text-green-800',
          icon: <CheckCircleIcon className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8631" />
        };
      case 'Archived':
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          icon: <ArchiveIcon className={`${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} mr-1`} data-id="element-8632" />
        };
      default:
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          icon: null
        };
    }
  };
  const styles = getStatusStyles();
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs';
  return <span className={`inline-flex items-center ${sizeClasses} rounded-full font-medium ${styles.bg} ${styles.text}`} data-id="element-8633">
      {styles.icon}
      {status}
    </span>;
}